<template lang="pug">
.mx-auto.max-w-3xl.w-full(ref="canvasContainer")
  .canvas-container
    .h-0.w-0.overflow-hidden
      v-stage(ref="konva" :config="canvasConfig")
        v-layer
          v-image(v-if="baseImage" :config="configBase")
          v-text(:config="{text:name, letterSpacing:2, x:824, y: 208, fontFamily:'Bebas Neue', fontSize:72, fill:'#FFF' }")
          v-text(:config="{text:status.ap, align:'center', width:120, x:699, y: 352, fontFamily:'Bebas Neue', fontSize:64, fill:'#FFF' }")
          v-text(:config="{text:status.dp, align:'center', width:120, x:832, y: 352, fontFamily:'Bebas Neue', fontSize:64, fill:'#FFF' }")
          v-text(:config="{text:status.mb, align:'center', width:120, x:962, y: 352, fontFamily:'Bebas Neue', fontSize:64, fill:'#FFF' }")
        magrobo(@update="canvasImageToURL")
    img.absolute.inset-0(:src="canvasImageURL")
</template>
<style lang="sass" scoped>
.canvas-container
  @apply overflow-hidden relative shadow-3xl bg-black
  &::after
    content: ""
    display: block
    padding-bottom: 640 / 1140 * 100%
  @screen md
    @apply rounded
</style>
<script>
const debounce = require("lodash/debounce");
import { mapGetters } from "vuex";
import Magrobo from "@/components/status/magrobo";
export default {
  components: {
    Magrobo
  },
  data() {
    return {
      baseImage: null,
      canvasImageURL: ""
    };
  },
  computed: {
    ...mapGetters("magrobo", ["status"]),
    name() {
      return this.$store.state.magrobo.name;
    },
    canvasConfig() {
      return {
        width: 1140,
        height: 640
      };
    },
    configBase() {
      let config = {
        image: this.baseImage,
        width: 1140,
        height: 640,
        x: 0,
        y: 0
      };
      return config;
    }
  },
  created() {
    const image = new Image();
    image.onload = () => {
      this.baseImage = image;
      this.canvasImageToURL();
    };
    image.src = "images/common/shareImage.jpg";
  },
  mounted() {
    this.$nextTick(this.canvasImageToURL);
  },
  methods: {
    canvasImageToURL: debounce(
      function() {
        const konva = this.$refs.konva;
        const stage = konva.getStage();
        stage.draw();
        this.canvasImageURL = stage.toDataURL({
          mimeType: "image/jpeg",
          quality: "0.85",
          width: 1138,
          pixelRatio: 1.6875 * 0.625
        });
      },
      100,
      { maxWait: 500 }
    )
  }
};
</script>
